import React, { useContext, useState, useRef, useEffect, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { Box, Button, Text, FormControl, Input, FlatList, Select } from 'native-base'

import { Context as LanguageContext } from '../../context/LanguageContext'
import { Context as AuthContext } from '../../context/AuthContext'
import { Context as MembersContext } from '../../context/MembersContext'

import {I18n} from 'i18n-js';
import AppTranslations from '../../../src/i18n/i18n'

import { applyMembersFilters, validateCNP } from '../../api/members';
import { hasOwnProperties } from '../../api/object';

const i18n = new I18n({
    ...AppTranslations
  });
  
i18n.enableFallback = true;

const MemberCNPFilter = () => {

    const authCtx = useContext(AuthContext)
    const membersCtx = useContext(MembersContext)
    
    const languageCtx = useContext(LanguageContext)
    i18n.locale = languageCtx.state;

    const [errors, setErrors] = useState({})

    const memberCNPInputRef = useRef()

    return <Box>

        {/* <Text>Errors: {JSON.stringify(errors)} </Text> */}
        
        <FormControl isInvalid={'CNP' in errors}>
            <FormControl.Label _text={{bold: true}}>
                {i18n.t('CNP')}
            </FormControl.Label>
            <Input placeholder={i18n.t('CNP')} 
                value={membersCtx?.state?.filters?.CNP}                
                ref={memberCNPInputRef}
                onSubmitEditing={() => {

                    applyMembersFilters(membersCtx)
                    memberCNPInputRef.current.focus()
                }}
                onChangeText={value => {

                    const crtError = validateCNP(value)

                    if (hasOwnProperties(crtError)) {

                        setErrors({
                            ...errors,
                            ...crtError
                        })
                    } else {

                        delete errors.CNP
                        setErrors(errors)
                    }

                    membersCtx.setFilters({
                        ...membersCtx?.state?.filters, 
                        CNP: value
                    })    
                    
                }}
            />
            
            {
                'CNP' in errors ? 
                <FormControl.ErrorMessage _text={{fontSize: 'xs'}}>
                    { i18n.t(errors.CNP) }
                </FormControl.ErrorMessage> : null
                // <FormControl.HelperText _text={{fontSize: 'xs'}}>
                //     {i18n.t('msgNameIsMandatory')}
                // </FormControl.HelperText>
            }
        </FormControl>

    </Box>
};

const styles = StyleSheet.create({ 
    container: {
        borderWidth: 1
    },
    backgroundImage: {
        flex: 1
    }
})

export default MemberCNPFilter;